import axios from 'axios';
import { ENV_CONFIG } from '../config/env';
import { logger } from '../utils/logger';

const API_KEY = ENV_CONFIG.GEOCODE_API_KEY;
const BASE_URL = 'https://api.opencagedata.com/geocode/v1/json';

export async function geocodeAddress(address: string) {
    logger.log('🌍 Geocoding address:', address);

    if (!API_KEY) {
        throw new Error('API key não configurada. Verifique o arquivo .env');
    }

    try {
        const { data } = await axios.get(BASE_URL, {
            params: { q: address, key: API_KEY, limit: 1 },
        });

        if (!data.results || data.results.length === 0) {
            throw new Error('Endereço não encontrado. Verifique se o endereço está correto.');
        }

        const { lat, lng } = data.results[0].geometry;
        const result = { latitude: lat, longitude: lng };

        logger.log('Geocoding result:', result);

        return result;
    } catch (error: any) {
        logger.error('Geocoding error:', error);

        if (error.response?.status === 401) {
            throw new Error('Chave de API inválida. Verifique a configuração.');
        } else if (error.response?.status === 403) {
            throw new Error('Limite de requisições excedido. Tente novamente mais tarde.');
        } else if (error.message) {
            throw error;
        } else {
            throw new Error('Erro ao buscar endereço. Verifique sua conexão.');
        }
    }
}